import { type SportMarket } from '@/Overtime/types/markets'
import { isCombinedPositionsMarket, isDoubleChanceMarket } from 'overtime-utils'

export const getGridMinMaxPercentage = (
  market: SportMarket,
  isMobile: boolean
): number => {
  return isMobile &&
    (isDoubleChanceMarket(market.typeId) ||
      isCombinedPositionsMarket(market.typeId))
    ? 100
    : market.odds.length === 3
      ? 33
      : 50
}
